<div class="z-tooltip fixed" #tooltipEl>
	<div
		class="z-tooltip fixed text-white text-xs font-light max-w-48 w-max py-1 px-2 text-left rounded bg-secondary-800 opacity-0"
		[ngClass]="styleClasses()"
		[style.left]="calculatedLeft()"
		[style.top]="calculatedTop()"
		[innerHTML]="tooltip() | trusted"
		#tooltipContent
	></div>
	<div
		class="z-tooltip fixed size-0 border-4 border-solid opacity-0"
		[ngClass]="caretStyleClasses()"
		[style.left]="caretX() ? caretX() + 'px' : ''"
		[style.top]="caretY() ? caretY() + 'px' : ''"
	></div>
</div>
